import PageHero from '../components/PageHero';
import { services } from '../data';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import SEO from '../components/SEO';

export default function Services() {
  return (
    <main className="bg-white">
      <SEO 
        title="Vores Ydelser | Rådgivning inden for Økonomi & Jura – FINANJU"
        description="Udforsk FINANJUs ydelser: Økonomisk rådgivning, juridisk rådgivning, interim opgaver og full-service løsninger skræddersyet til din virksomheds behov."
        path="/ydelser"
      />
      <PageHero
        title="Vores Ydelser"
        subtitle="Professionel økonomisk og juridisk rådgivning skræddersyet til din virksomheds behov."
        breadcrumbs={[{ name: 'Ydelser', href: '/ydelser' }]}
      />

      <section className="py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {services.map((service) => (
              <div key={service.id} className="bg-slate-50 p-10 rounded-sm border border-slate-100 group hover:border-[#876a57]/20 transition-all flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-4 mb-8">
                    <div className="w-14 h-14 bg-white rounded-sm flex items-center justify-center text-slate-400 group-hover:text-[#876a57] group-hover:bg-[#876a57]/10 transition-colors shadow-sm">
                      <service.icon className="h-7 w-7" />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-900">{service.title}</h2>
                  </div>
                  <p className="text-slate-500 mb-8 leading-relaxed">
                    {service.description}
                  </p>
                  <div className="space-y-4 mb-10">
                    {service.bullets.map((point, i) => (
                      <div key={i} className="flex items-start gap-3">
                        <CheckCircle2 className="h-5 w-5 text-[#876a57] shrink-0 mt-0.5" />
                        <span className="text-slate-600 text-sm">{point}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <Link 
                    to={service.link} 
                    className="inline-flex items-center gap-2 font-semibold text-[#876a57] hover:text-[#876a57]/90 transition-colors text-sm uppercase tracking-wide"
                  >
                    Hør mere om {service.title.toLowerCase()} <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cta Section */}
      <section className="py-24 bg-slate-900 text-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">Er du i tvivl om, hvilken løsning der passer bedst?</h2>
          <p className="text-lg text-slate-300 mb-10 leading-relaxed max-w-2xl mx-auto">
            Lad os tage en uforpligtende dialog om din virksomheds situation og finde den rette vej frem, sammen.
          </p>
          <Link to="/kontakt" className="cta-button">
            Kontakt os for vejledning
          </Link>
        </div>
      </section>
    </main>
  );
}
